import React, { useState, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { language } from '../../stores/slices/languageSlice'
import Input from '../input/Input'
import { UserContext } from '../../stores/Context/Context'
import validateInput from '../../utilities/validations/validateInput'
import { toast } from 'react-toastify'
import style from './appintake.module.css'
import { smartyStreetApi } from '../../stores/slices/smartyStreetSlice'
import { lookUp } from '../../stores/slices/lookupSlice'
import { useEffect } from 'react'
import { authorizedPersonData } from '../../stores/slices/patientSearch/patientSearchSlice'
import { Trash2 } from 'react-feather'

function AuthorizedPerson() {
  const [isAuthorized, setIsAuthorized] = useState(false)
  const patientInformation = useSelector((state) => state.patientSearchSlice);
  const [authorizedPersonInfo, setAuthorizedPersonInfo] = useState({
    0: {
      firstName: { value: "", isValid: true },
      lastName: { value: "", isValid: true },
      suffix: { value: "", isValid: true },
      relationshipToPatient: { value: "", isValid: true },
      addressLine1: { value: "", isValid: true },
      addressLine2: { value: "", isValid: true },
      city: { value: "", isValid: true },
      state: { value: "", isValid: true },
      zipcode: { value: "", isValid: true },
      phoneType: { value: "", isValid: true },
      phoneNumber: { value: "", isValid: true, errorMsg:false },
      isAddressChecked: true,
      isPhoneNumberChecked: true,
      isAddressVerified: false,
      isCopySent: false,
      email: { value: "", isValid: true },
      hasDuplicate: false,
      smartyStreetMatches: {
        NoMatch: false,
        PartialMatch: false,
        SecInfoNotMatch: false,
        ExactMatch: false,
      },
      ss_msg_cls: '',
      ss_msg: '',
    }
  })
  const [duplicateAuthPerson, setDuplicateAuthPerson] = useState([])
  const [chechFlag, setCheckFlag] = useState(false)
  const errorMessage = useSelector(language).errorMessage
  let wizardValidation = useContext(UserContext)

  const selectedLanguage = useSelector(language).Appintake.authorizedPerson
  const lookUpData = useSelector(lookUp);
  const dispatch = useDispatch()


  useEffect(() => {
    if (patientInformation.authorizedPerson && patientInformation.isAuthorizedPersonAvailable) {
      setIsAuthorized(patientInformation.isAuthorizedPersonAvailable)
      setAuthorizedPersonInfo(patientInformation.authorizedPerson)
    }
  }, [])

  //Authorized Person Inputs with onChange Validation
  const authInputs = (index) => {
    let authorizedPerson = authorizedPersonInfo[index]
    const inputOnChange = (e, fieldvalidation) => {
      setDuplicateAuthPerson([])
      let inputValue = e.target.value;
      let name = e.target.name;
      let inputValidate = validateInput(inputValue, fieldvalidation);
      if (name == "isAddressChecked") {
        authorizedPerson = {
          ...authorizedPerson, [name]: e.target.checked, hasDuplicate: false, addressLine1: { value: "", isValid: true },
          addressLine2: { value: "", isValid: true },
          city: { value: "", isValid: true },
          state: { value: "", isValid: true },
          zipcode: { value: "", isValid: true },
        }
      } else if (name == "isPhoneNumberChecked") {
        authorizedPerson = {
          ...authorizedPerson, [name]: e.target.checked, hasDuplicate: false, phoneType: { value: "", isValid: true },
          phoneNumber: { value: "", isValid: true },
        }
      } else if (name == "isCopySent") {
        authorizedPerson = { ...authorizedPerson, [name]: e.target.checked, hasDuplicate: false, email: { value: "", isValid: true }, }
      } else if (name == "zipcode" || name == "city" || name == "state" || name == "addressLine2" || name == "addressLine1") {
        authorizedPerson = {
          ...authorizedPerson,
          [name]: { value: inputValidate.value, isValid: inputValidate.isValid },
          smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
          },
          ss_msg_cls: '',
          ss_msg: '',
        }
      } else {
        if(name=='phoneNumber'){
          authorizedPerson = { ...authorizedPerson, [name]: { value: inputValidate.value, isValid: inputValidate.isValid, errorMsg:inputValidate.errorMsg}, hasDuplicate: false }
        }else{
          authorizedPerson = { ...authorizedPerson, [name]: { value: inputValidate.value, isValid: inputValidate.isValid }, hasDuplicate: false }

        }
      }

      const changeHasDuplicateFlag = Object.keys(authorizedPersonInfo).length > 0 && Object.keys(authorizedPersonInfo).map((data) => {
        let value = { ...authorizedPersonInfo[data] }
        value.hasDuplicate = false
        return value
      })
      setAuthorizedPersonInfo(changeHasDuplicateFlag)
      setAuthorizedPersonInfo(prevState => ({
        ...prevState,
        [index]: authorizedPerson
      }))
    }
    const onClickVerifyAddress = () => {
      const validateAddress = authorizedPerson.addressLine1.value != "" && authorizedPerson.city.value != "" && authorizedPerson.state.value != "" && authorizedPerson.zipcode.value != "" && authorizedPerson.addressLine1.isValid && authorizedPerson.addressLine2.isValid && authorizedPerson.city.isValid && authorizedPerson.state.isValid && authorizedPerson.zipcode.isValid
      setAuthorizedPersonInfo(prevState => ({
        ...prevState,
        [index]: {
          ...authorizedPersonInfo[index],
          isAddressVerified: validateAddress
        }
      }))
      if (validateAddress) {
        const address = {
          addressLine1: authorizedPerson.addressLine1.value,
          addressLine2: authorizedPerson.addressLine2.value,
          city: authorizedPerson.city.value,
          state: authorizedPerson.state.value,
          zipCode: authorizedPerson.zipcode.value,
        };
        dispatch(smartyStreetApi({ address, callbackVerifiedAddress }));
      } else {
        toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        setAuthorizedPersonInfo((prevState) => ({
          ...prevState,
          [index]: {
            ...authorizedPersonInfo[index],
            addressLine1: {
              value: authorizedPersonInfo[index].addressLine1.value,
              isValid: authorizedPersonInfo[index].addressLine1.isValid && authorizedPersonInfo[index].addressLine1.value != '',
            },
            addressLine2: {
              value: authorizedPersonInfo[index].addressLine2.value,
              isValid: authorizedPersonInfo[index].addressLine2.isValid,
            },
            city: {
              value: authorizedPersonInfo[index].city.value,
              isValid: authorizedPersonInfo[index].city.isValid && authorizedPersonInfo[index].city.value != '',
            },
            state: {
              value: authorizedPersonInfo[index].state.value,
              isValid: authorizedPersonInfo[index].state.isValid && authorizedPersonInfo[index].state.value != '',
            },
            zipcode: {
              value: authorizedPersonInfo[index].zipcode.value,
              isValid: authorizedPersonInfo[index].zipcode.isValid && authorizedPersonInfo[index].zipcode.value != '',
            }
          }
        }));
      }
    }

    const callbackVerifiedAddress = (address) => {
      if (address?.isValidateAddress != undefined && address.isValidateAddress == "ExactMatch") {
        setAuthorizedPersonInfo((prevState) => ({
          ...prevState,
          [index]: {
            ...authorizedPersonInfo[index],
            addressLine1: {
              value: address.street,
              isValid: authorizedPersonInfo[index].addressLine1.isValid,
            },
            addressLine2: {
              value: address.street2,
              isValid: authorizedPersonInfo[index].addressLine2.isValid,
            },
            city: {
              value: address.city,
              isValid: authorizedPersonInfo[index].city.isValid,
            },
            state: {
              value: address.state,
              isValid: authorizedPersonInfo[index].state.isValid,
            },
            zipcode: {
              value: address.zipcode,
              isValid: authorizedPersonInfo[index].zipcode.isValid,
            },
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_success",
            ss_msg: errorMessage.smartyStreetMsg.sucessMsg,
            isAddressVerified: true,
          }
        }));

      } else {
        setAuthorizedPersonInfo((prevState) => ({
          ...prevState,
          [index]: {
            ...authorizedPersonInfo[index],
            addressLine1: {
              value: address.street,
              isValid: authorizedPersonInfo[index].addressLine1.isValid,
            },
            addressLine2: {
              value: address.street2,
              isValid: authorizedPersonInfo[index].addressLine2.isValid,
            },
            city: {
              value: address.city,
              isValid: authorizedPersonInfo[index].city.isValid,
            },
            state: {
              value: address.state,
              isValid: authorizedPersonInfo[index].state.isValid,
            },
            zipcode: {
              value: address.zipcode,
              isValid: authorizedPersonInfo[index].zipcode.isValid,
            },
            smartyStreetMatches: {
              NoMatch: address.NoMatch,
              PartialMatch: address.PartialMatch,
              SecInfoNotMatch: address.SecInfoNotMatch,
              ExactMatch: address.ExactMatch,
            },
            ss_msg_cls: "ss_error",
            ss_msg: errorMessage.smartyStreetMsg.errorMsg,
            isAddressVerified: true,
          }
        }));
      }
    }

    const removeImage = (e, index) => {
      e.preventDefault()
      let UploadDocuments_copy = { ...authorizedPersonInfo }
      delete UploadDocuments_copy[index]
      let obj = {}
      Object.keys(UploadDocuments_copy).length > 0 && Object.keys(UploadDocuments_copy).map((data, indice) => {
        obj = { ...obj, [indice]: authorizedPersonInfo[data] }
      })
      setAuthorizedPersonInfo(obj)

    }

    return <div className={authorizedPerson?.hasDuplicate && style.err_border}>
      {Object.keys(authorizedPersonInfo).length > 1 && <div className='d-flex pointer justify-content-end color-danger pt-5' onClick={(e) => removeImage(e, index)}><Trash2 /> </div>}
      <div className="grid columns-12 gap-4 gap-y-5 p-8 mb-5">
        <Input
          type="text"
          id={"firstName" + index}
          label={selectedLanguage.firstName}
          name="firstName"
          value={authorizedPerson.firstName.value}
          onChange={(e) => inputOnChange(e, "name")}
          isValid={authorizedPerson.firstName.isValid}
          maxLength="30"
          errorMsg={errorMessage?.inputErrorMessage}
        />
        <Input
          type="text"
          id={"lastName" + index}
          label={selectedLanguage.lastName}
          name="lastName"
          value={authorizedPerson.lastName.value}
          onChange={(e) => inputOnChange(e, "name")}
          isValid={authorizedPerson.lastName.isValid}
          maxLength="30"
          errorMsg={errorMessage?.inputErrorMessage}
        />
        <Input
          type="select"
          id={"suffix" + index}
          label={selectedLanguage?.suffix}
          name="suffix"
          value={authorizedPerson.suffix.value}
          onChange={(e) => inputOnChange(e, "dropDown")}
          isValid={authorizedPerson.suffix.isValid}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.suffix}
        />
        <Input
          type="select"
          id={"relationshipToPatient" + index}
          label={selectedLanguage?.relationshipToPatient}
          name="relationshipToPatient"
          value={authorizedPerson.relationshipToPatient.value}
          onChange={(e) => inputOnChange(e, 'dropDown')}
          isValid={authorizedPerson.relationshipToPatient.isValid}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.authRelationshipToPatient}
        />
      </div>
      <div className='row mt-5 mb-5'>
        <div className='col-8 mt-5 ps-5 '>
          <Input
            type="switch1"
            id={"isCopySent" + index}
            labelPosition="left"
            name="isCopySent"
            label={selectedLanguage.isCopySwitch}
            value={authorizedPerson.isCopySent}
            onClick={inputOnChange}
          />
        </div>
        {authorizedPerson.isCopySent && <div className="col-4 mt-5">
          <Input
            type="email"
            id={"email" + index}
            label={selectedLanguage.email}
            name="email"
            value={authorizedPerson.email.value}
            onChange={(e) => inputOnChange(e, 'email')}
            isValid={authorizedPerson.email.isValid}
            maxLength="100"
            errorMsg={errorMessage?.inputErrorMessage}
          />
        </div>}
      </div>
      <div className='row mt-5 p-8 mb-5'>
        <Input
          type="switch2"
          id={"isAddressChecked" + index}
          name="isAddressChecked"
          label={selectedLanguage.sameAddress}
          value={authorizedPerson.isAddressChecked}
          onClick={inputOnChange}
        />
        <Input
          type="switch2"
          id={"isPhoneNumberChecked" + index}
          name="isPhoneNumberChecked"
          label={selectedLanguage.samePhoneNumber}
          value={authorizedPerson.isPhoneNumberChecked}
          onClick={inputOnChange}
        />
      </div>
      {/* if the Address toggle is falses */}
      {!authorizedPerson.isAddressChecked && <>
        <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-1">
          <Input
            type="text"
            id={`addressLine1${index}`}
            label={selectedLanguage.addressLine1}
            name="addressLine1"
            value={authorizedPerson.addressLine1.value}
            onChange={(e) => inputOnChange(e, "address")}
            isValid={authorizedPerson.addressLine1.isValid}
            maxLength="100"
            errorMsg={errorMessage?.inputErrorMessage}
          />
          <Input
            type="text"
            id={"addressLine2" + index}
            label={selectedLanguage.addressLine2}
            name="addressLine2"
            value={authorizedPerson.addressLine2.value}
            onChange={(e) => inputOnChange(e, "addressLine2")}
            isValid={authorizedPerson.addressLine2.isValid}
            maxLength="100"
            errorMsg={errorMessage?.inputErrorMessage}
          />
          <Input
            type="text"
            id={"city" + index}
            label={selectedLanguage.city}
            name="city"
            value={authorizedPerson.city.value}
            onChange={(e) => inputOnChange(e, "city")}
            isValid={authorizedPerson.city.isValid}
            maxLength="50"
            errorMsg={errorMessage?.inputErrorMessage}
          />
          <Input
            type="select"
            id={"state" + index}
            label={selectedLanguage?.state}
            name="state"
            value={authorizedPerson.state.value}
            onChange={(e) => inputOnChange(e, 'state')}
            isValid={authorizedPerson.state.isValid}
            errorMsg={errorMessage?.inputErrorMessage}
            maxLength="100"
            elmentconfig={lookUpData.State}
          />
          <Input
            type="text"
            id={"zipcode" + index}
            label={selectedLanguage.zipcode}
            name="zipcode"
            value={authorizedPerson.zipcode.value}
            onChange={(e) => inputOnChange(e, "zipcode")}
            isValid={authorizedPerson.zipcode.isValid}
            maxLength="5"
            errorMsg={errorMessage?.inputErrorMessage}
          />
        </div>
        <div className={`${authorizedPerson.ss_msg_cls} intro-y g-col-12 g-col-md-12 g-col-xl-12 mt-4 px-8`}>
          {authorizedPerson.ss_msg}
          <div className="px-8 mt-1">
            <button className="btn verifyAddres ms-2 z-10" onClick={onClickVerifyAddress} >
              {selectedLanguage.verifyAddress}
            </button>
          </div>
        </div>
      </>}
      {/* if the Phone Number toggle is false */}
      {!authorizedPerson.isPhoneNumberChecked && <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-1">
        <Input
          type="select"
          id={"phoneType" + index}
          label={selectedLanguage?.phoneType}
          name="phoneType"
          value={authorizedPerson.phoneType.value}
          onChange={(e) => inputOnChange(e, 'dropDown')}
          isValid={authorizedPerson.phoneType.isValid}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
          elmentconfig={lookUpData.phoneType}
        />
        <Input
          type="text"
          id={"phoneNumber" + index}
          label={selectedLanguage.phoneNumber}
          name="phoneNumber"
          value={authorizedPerson.phoneNumber.value}
          onChange={(e) => inputOnChange(e, "phoneNumber")}
          isValid={authorizedPerson.phoneNumber.isValid}
          maxLength="12"
          errorMsg={authorizedPerson.phoneNumber.errorMsg  ?  "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
        />
      </div>}
    </div>
  }

  //Authorized person overall validation
  const authorizedPersonValidation = () => {
    const authValidation = Object.keys(authorizedPersonInfo).map((val, i) => {
      const authorizedPerson = authorizedPersonInfo[i]
      const isValidAuthorizedPerson = authorizedPerson.firstName.value != "" && authorizedPerson.firstName.isValid && authorizedPerson.lastName.value != "" && authorizedPerson.lastName.isValid && authorizedPerson.suffix.isValid && authorizedPerson.relationshipToPatient.value != "" && authorizedPerson.relationshipToPatient.isValid
      let isValidAddress
      if (authorizedPerson.isAddressChecked) {
        isValidAddress = true
      } else {
        isValidAddress = authorizedPerson.addressLine1.value != "" && authorizedPerson.addressLine1.isValid && authorizedPerson.addressLine2.isValid && authorizedPerson.city.value != "" && authorizedPerson.city.isValid && authorizedPerson.state.value != "" && authorizedPerson.state.isValid && authorizedPerson.zipcode.value != "" && authorizedPerson.zipcode.isValid && authorizedPerson.isAddressVerified
        isAuthorized && !isValidAddress && !authorizedPerson.isAddressVerified && toast.error("Please Verify the Address")
      }

      let isValidPhoneNumber
      if (authorizedPerson.isPhoneNumberChecked) {
        isValidPhoneNumber = true
      } else {
        isValidPhoneNumber = authorizedPerson.phoneType.value != "" && authorizedPerson.phoneType.isValid && authorizedPerson.phoneNumber.value != "" && authorizedPerson.phoneNumber.isValid
      }

      const copySent = authorizedPerson.isCopySent ? (authorizedPerson.email.value != "" && authorizedPerson.email.isValid) : true
      //checking all the authorized fileds are valid
      if (isAuthorized) {
        if (isValidAuthorizedPerson && isValidAddress && isValidPhoneNumber && copySent) {
          //if all the authorized fileds are valid then validating duplicate data
          const duplicateData = []
          let obj = {
            firstName: { value: "", isValid: true },
            lastName: { value: "", isValid: true },
            suffix: { value: "", isValid: true },
            relationshipToPatient: { value: "", isValid: true },
            addressLine1: { value: "", isValid: true },
            addressLine2: { value: "", isValid: true },
            city: { value: "", isValid: true },
            state: { value: "", isValid: true },
            zipcode: { value: "", isValid: true },
            phoneType: { value: "", isValid: true },
            phoneNumber: { value: "", isValid: true, errorMsg:false },
            isAddressChecked: true,
            isPhoneNumberChecked: true,
            isAddressVerified: false,
            isCopySent: false,
            email: { value: "", isValid: true },
            hasDuplicate: false,
            smartyStreetMatches: {
              NoMatch: false,
              PartialMatch: false,
              SecInfoNotMatch: false,
              ExactMatch: false,
            },
            ss_msg_cls: '',
            ss_msg: '',
          }
          Object.keys(authorizedPersonInfo).map((value, ind) => {
            const stringOne = JSON.stringify(authorizedPersonInfo[i].firstName.value.toLowerCase() + authorizedPersonInfo[i].lastName.value.toLowerCase() + authorizedPersonInfo[i].suffix.value + authorizedPersonInfo[i].addressLine1.value.toLowerCase() + authorizedPersonInfo[i].addressLine2.value.toLowerCase() + authorizedPersonInfo[i].city.value.toLowerCase() + authorizedPersonInfo[i].state.value + authorizedPersonInfo[i].zipcode.value)
            const stringTwo = JSON.stringify(authorizedPersonInfo[ind].firstName.value.toLowerCase() + authorizedPersonInfo[ind].lastName.value.toLowerCase() + authorizedPersonInfo[ind].suffix.value + authorizedPersonInfo[ind].addressLine1.value.toLowerCase() + authorizedPersonInfo[ind].addressLine2.value.toLowerCase() + authorizedPersonInfo[ind].city.value.toLowerCase() + authorizedPersonInfo[ind].state.value + authorizedPersonInfo[ind].zipcode.value)
            if (i != ind && stringOne == stringTwo) {
              duplicateData.push(i, ind)
              return false
            }
          })
          let duplicateIndex = [...new Set(duplicateData)]
          if (duplicateIndex.length > 0) {
            duplicateAuthPerson.length == 0 && setDuplicateAuthPerson(duplicateIndex)
            duplicateIndex.map((indice) => {
              setAuthorizedPersonInfo(prevState => ({
                ...prevState,
                [indice]: { ...authorizedPersonInfo[indice], hasDuplicate: true }
              }))
            })
            return false
          }
          return true
        } else {
          toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
          setAuthorizedPersonInfo((prevState) => ({
            ...prevState,
            [i]: {
              ...authorizedPersonInfo[i],
              firstName: {
                value: authorizedPersonInfo[i].firstName.value,
                isValid: authorizedPersonInfo[i].firstName.value == "" ? false : authorizedPersonInfo[i].firstName.isValid
              },
              lastName: {
                value: authorizedPersonInfo[i].lastName.value,
                isValid: authorizedPersonInfo[i].lastName.value == "" ? false : authorizedPersonInfo[i].lastName.isValid
              },
              suffix: {
                value: authorizedPersonInfo[i].suffix.value,
                isValid: authorizedPersonInfo[i].suffix.isValid
              },
              relationshipToPatient: {
                value: authorizedPersonInfo[i].relationshipToPatient.value,
                isValid: authorizedPersonInfo[i].relationshipToPatient.value == "" ? false : authorizedPersonInfo[i].relationshipToPatient.isValid
              },
              addressLine1: {
                value: authorizedPersonInfo[i].addressLine1.value,
                isValid: authorizedPersonInfo[i].isAddressChecked ? authorizedPersonInfo[i].addressLine1.isValid : (authorizedPersonInfo[i].addressLine1.value != "" && authorizedPersonInfo[i].addressLine1.isValid)
              },
              addressLine2: {
                value: authorizedPersonInfo[i].addressLine2.value,
                isValid: authorizedPersonInfo[i].addressLine2.isValid
              },
              city: {
                value: authorizedPersonInfo[i].city.value,
                isValid: authorizedPersonInfo[i].isAddressChecked ? authorizedPersonInfo[i].city.isValid : (authorizedPersonInfo[i].city.value != "" && authorizedPersonInfo[i].city.isValid)
              },
              state: {
                value: authorizedPersonInfo[i].state.value,
                isValid: authorizedPersonInfo[i].isAddressChecked ? authorizedPersonInfo[i].state.isValid : (authorizedPersonInfo[i].state.value != "" && authorizedPersonInfo[i].state.isValid)
              },
              zipcode: {
                value: authorizedPersonInfo[i].zipcode.value,
                isValid: authorizedPersonInfo[i].isAddressChecked ? authorizedPersonInfo[i].zipcode.isValid : (authorizedPersonInfo[i].zipcode.value != "" && authorizedPersonInfo[i].zipcode.isValid)
              },
              phoneType: {
                value: authorizedPersonInfo[i].phoneType.value,
                isValid: authorizedPersonInfo[i].isPhoneNumberChecked ? authorizedPersonInfo[i].phoneType.isValid : (authorizedPersonInfo[i].phoneType.value != "" && authorizedPersonInfo[i].phoneType.isValid)
              },
              phoneNumber: {
                value: authorizedPersonInfo[i].phoneNumber.value,
                isValid: authorizedPersonInfo[i].isPhoneNumberChecked ? authorizedPersonInfo[i].phoneNumber.isValid : (authorizedPersonInfo[i].phoneNumber.value != "" && authorizedPersonInfo[i].phoneNumber.isValid)
              },
              email: {
                value: authorizedPersonInfo[i].email.value,
                isValid: authorizedPersonInfo[i].email.value == "" ? false : authorizedPersonInfo[i].email.isValid
              },
              hasDuplicate: false
            },
          }))
          return false
        }
      } else {
        return true
      }
    })
    dispatch(authorizedPersonData({ authorizedPersonInfo, isAuthorized }))
    return authValidation.every((valid) => valid == true)
  }
  wizardValidation.formValidation.isValidate = authorizedPersonValidation

  //Adding Extra Authorized person
  const addOneMoreAuthorizedPerson = (e, index) => {
    //checking duplicate data and valid input values
    if (authorizedPersonValidation()) {
      setAuthorizedPersonInfo(prevState => ({
        ...prevState,
        [index]: {
          firstName: { value: "", isValid: true },
          lastName: { value: "", isValid: true },
          suffix: { value: "", isValid: true },
          relationshipToPatient: { value: "", isValid: true },
          addressLine1: { value: "", isValid: true },
          addressLine2: { value: "", isValid: true },
          city: { value: "", isValid: true },
          state: { value: "", isValid: true },
          zipcode: { value: "", isValid: true },
          phoneType: { value: "", isValid: true },
          phoneNumber: { value: "", isValid: true, errorMsg:false },
          isAddressChecked: true,
          isPhoneNumberChecked: true,
          isAddressVerified: false,
          isCopySent: false,
          email: { value: "", isValid: true },
          hasDuplicate: false,
          smartyStreetMatches: {
            NoMatch: false,
            PartialMatch: false,
            SecInfoNotMatch: false,
            ExactMatch: false,
          },
          ss_msg_cls: '',
          ss_msg: '',
        }
      }))
    }
  }

  if (duplicateAuthPerson.length > 0) {
    toast.error("Duplicate Authorized Persons are not allowed. Please correct your input.")
  }

  return (
    <React.Fragment>
      <div className="intro-y g-col-12 g-col-sm-12 text-center p-4 lh-6">
        <p style={{ textAlign: "left" }} className='mb-3'>
          {patientInformation.patientInformation.Program == "CPR" ? selectedLanguage.authorizedPersonInfoCPR : selectedLanguage.authorizedPersonInfo}
        </p>
        <Input
          type="switch"
          id="auth"
          labelPosition="left"
          name="authorized_person"
          label={selectedLanguage.authorizedPersonQuestion}
          value={isAuthorized}
          onClick={(e) => setIsAuthorized(e.target.checked)}
        />
      </div>
      {isAuthorized && Object.keys(authorizedPersonInfo).length > 0 && Object.keys(authorizedPersonInfo).map((val, index) => {
        return authInputs(index)
      })}
      {isAuthorized && <div style={{ textAlign: "center" }} className="mt-10 mb-4"><button className="btn verifyAddres ms-2 z-10" onClick={(e) => addOneMoreAuthorizedPerson(e, Object.keys(authorizedPersonInfo).length)} >{selectedLanguage.addOneMore}</button></div>}
    </React.Fragment >
  )
}

export default AuthorizedPerson